// RevokeConfirmationModal.js
import { Dialog, DialogActions, DialogContent, DialogTitle, Button } from "@mui/material";

const RevokeConfirmationModal = ({ open, onClose, onConfirm }) => {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Confirm Revoke</DialogTitle>
      <DialogContent>
        Are you sure you want to revoke this notification?
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          Cancel
        </Button>
        <Button onClick={onConfirm} color="secondary">
          Confirm
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default RevokeConfirmationModal;
